import { isValidPairingCode, normalizePairingCode } from '../../../pair/pairingCode';

/**
 * Extract a pairing code from QR payload text.
 * Accepts the dashboard deep link (`/pair?code=…`) or a bare code.
 */
export function parsePairingScan(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  try {
    const url = new URL(trimmed);
    const fromQuery = url.searchParams.get('code');
    if (fromQuery) {
      const code = normalizePairingCode(fromQuery);
      return isValidPairingCode(code) ? code : null;
    }
  } catch {
    /* not a URL — try bare code */
  }

  const code = normalizePairingCode(trimmed);
  return isValidPairingCode(code) ? code : null;
}
